import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { DiffusionModelsFilterInputSearch } from '../../_base/filters/diffusion_models_filter_input_search';

export function DiffusionModelsFilterInputSearchUD() {
  const dispatch = use_dispatch();

  const { current_table_page_settings } = use_slice_ml_asset(['current_table_page_settings']);

  /*
   * METHODS
   */

  function try_set_query(value: string) {
    let current_table_page_settings_new = current_table_page_settings.clone({ filter_query: value });

    dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
  }

  let try_set_query_debounced = use_debounced_function(try_set_query, CONSTANTS_TIME__client.DEBOUNCE_LOAD_DIFFUSION_MODELS_QUERY);

  /*
   * HTML
   */
  return <DiffusionModelsFilterInputSearch on_change={try_set_query_debounced} />;
}
